import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Layout/AuthLayout.vue";
import UserLayout from "@/views/Layout/UserLayout.vue";

import NotFound from "@/views/NotFoundPage.vue";

const routes = [
  {
    path: "/",
    name: "home2024",
    beforeEnter() {
      window.location.replace("https://appcampinas.com.br/midia-festival/");
    },
  },
  {
    path: "/2023",
    name: "home2023",
    component: () => import("../views/Pages/Public/Home2023.vue"),
  },
  {
    path: "/2022",
    name: "home2022",
    component: () => import("../views/Pages/Public/Home2022.vue"),
  },
  {
    path: "/2021",
    name: "home2021",
    component: () => import("../views/Pages/Public/Home2021.vue"),
  },
  {
    path: "/jurado/home",
    meta: { isJuradoRoute: true },
    component: UserLayout,
    children: [
      {
        path: "",
        name: "juradoHome",
        meta: { isJuradoRoute: true },
        component: () => import("../views/Pages/Jurado/Home.vue"),
      },
    ],
  },
  {
    path: "/usuario",
    meta: { isUserRoute: true },
    component: UserLayout,
    children: [
      {
        path: "",
        name: "usuarioHome",
        meta: { isUserRoute: true },
        component: () => import("../views/Pages/User/Home.vue"),
      },
      {
        path: "peca-publicitaria",
        name: "cadastroPecaPublicitaria",
        meta: { isUserRoute: true },
        component: () =>
          import(
            "../views/Pages/User/CadastroPeca/PecaPublicitariaUserForm.vue"
          ),
      },
      {
        path: "peca-estudante",
        name: "cadastroPecaEstudante",
        meta: { isUserRoute: true },
        component: () =>
          import("../views/Pages/User/CadastroPeca/PecaEstudanteUserForm.vue"),
      },
      {
        path: "peca-fornecedor",
        name: "cadastroPecaFornecedor",
        meta: { isUserRoute: true },
        component: () =>
          import("../views/Pages/User/CadastroPeca/PecaFornecedorUserForm.vue"),
      },
      {
        path: "peca-profissional-independente",
        name: "cadastroPecaProfissionalIndependente",
        meta: { isUserRoute: true },
        component: () =>
          import(
            "../views/Pages/User/CadastroPeca/PecaProfissionalIndependenteUserForm.vue"
          ),
      },
    ],
  },
  {
    path: "/admin",
    redirect: "/admin/dashboard",
    meta: { isAdminRoute: true },
    component: DashboardLayout,
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        meta: { isAdminRoute: true, hideFooter: true },
        component: () => import("../views/Pages/Admin/Dashboard/Index.vue"),
      },
      {
        path: "/icons",
        name: "Icons",
        meta: { isAdminRoute: true },
        component: () => import("../views/Icons.vue"),
      },
      {
        path: "/profile",
        name: "Profile",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/User/UserProfile.vue"),
      },
      {
        path: "/tables",
        name: "tables",
        meta: { isAdminRoute: true },
        component: () => import("../views/RegularTables.vue"),
      },
      {
        path: "agencias",
        name: "Agências",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/Publicitarios/List.vue"),
      },
      {
        path: "agencias/novo",
        name: "Nova Agência",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/Publicitarios/Form.vue"),
      },
      {
        path: "agencias/:id",
        name: "Edição de Agência",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/Publicitarios/Form.vue"),
      },
      {
        path: "pecas-publicitarias",
        name: "Peças Publicitárias",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/PecaPublicitarias/List.vue"),
      },
      {
        path: "pecas-publicitarias/novo",
        name: "Nova Peça Publicitária",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/PecaPublicitarias/Form.vue"),
      },
      {
        path: "pecas-publicitarias/:id",
        name: "Edição de Peça Publicitária",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/PecaPublicitarias/Form.vue"),
      },
      {
        path: "estudantes",
        name: "Estudantes",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/Estudantes/List.vue"),
      },
      {
        path: "estudantes/novo",
        name: "Novo Estudante",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/Estudantes/Form.vue"),
      },
      {
        path: "estudantes/:id",
        name: "Edição de Estudante",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/Estudantes/Form.vue"),
      },
      {
        path: "pecas-estudantes",
        name: "Peças de Estudantes",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/PecaEstudantes/List.vue"),
      },
      {
        path: "pecas-estudantes/novo",
        name: "Nova Peca de Estudante",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/PecaEstudantes/Form.vue"),
      },
      {
        path: "pecas-estudantes/:id",
        name: "Edição de Peca de Estudante",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/PecaEstudantes/Form.vue"),
      },
      {
        path: "fornecedores",
        name: "Fornecedores",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/Fornecedores/List.vue"),
      },
      {
        path: "fornecedores/novo",
        name: "Novo Fornecedor",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/Fornecedores/Form.vue"),
      },
      {
        path: "fornecedores/:id",
        name: "Edição de Fornecedor",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/Fornecedores/Form.vue"),
      },
      {
        path: "pecas-fornecedores",
        name: "Peças de Fornecedores",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/PecaFornecedores/List.vue"),
      },
      {
        path: "pecas-fornecedores/novo",
        name: "Nova Peça de Fornecedor",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/PecaFornecedores/Form.vue"),
      },
      {
        path: "pecas-fornecedores/:id",
        name: "Edição de Peça de Fornecedor",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/PecaFornecedores/Form.vue"),
      },
      {
        path: "profissional-independente",
        name: "Profissionais Independentes",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/ProfissionalIndependente/List.vue"),
      },
      {
        path: "profissional-independente/novo",
        name: "Novo Profissional Independente",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/ProfissionalIndependente/Form.vue"),
      },
      {
        path: "profissional-independente/:id",
        name: "Edição de Profissional Independente",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/ProfissionalIndependente/Form.vue"),
      },
      {
        path: "pecas-profissional-independente",
        name: "Peças de Profissionais Independentes",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/PecaProfissionalIndependente/List.vue"),
      },
      {
        path: "pecas-profissional-independente/novo",
        name: "Nova Peça de Profissional Independente",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/PecaProfissionalIndependente/Form.vue"),
      },
      {
        path: "pecas-profissional-independente/:id",
        name: "Edição de Peça de Profissional Independente",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/PecaProfissionalIndependente/Form.vue"),
      },
      {
        path: "profissionais",
        name: "Profissionais",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/Profissionais/List.vue"),
      },
      {
        path: "profissionais/novo",
        name: "Novo Profissional",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/Profissionais/Form.vue"),
      },
      {
        path: "profissionais/:id",
        name: "Edição de Profissional",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/Profissionais/Form.vue"),
      },
      {
        path: "categoria-peca-publicitaria",
        name: "Categoria Peça Publicitária",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/CategoriaPecaPublicitaria/List.vue"),
      },
      {
        path: "categoria-peca-publicitaria/novo",
        name: "Nova Categoria Peça Publicitária",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/CategoriaPecaPublicitaria/Form.vue"),
      },
      {
        path: "categoria-peca-publicitaria/:id",
        name: "Edição de Categoria Peça Publicitária",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/CategoriaPecaPublicitaria/Form.vue"),
      },
      {
        path: "categoria-peca-estudante",
        name: "Categoria Peça Estudante",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/CategoriaPecaEstudante/List.vue"),
      },
      {
        path: "categoria-peca-estudante/novo",
        name: "Nova Categoria Peça Estudante",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/CategoriaPecaEstudante/Form.vue"),
      },
      {
        path: "categoria-peca-estudante/:id",
        name: "Edição de Categoria Peça Estudante",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/CategoriaPecaEstudante/Form.vue"),
      },
      {
        path: "categoria-peca-fornecedor",
        name: "Categoria Peça Fornecedor",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/CategoriaPecaFornecedor/List.vue"),
      },
      {
        path: "categoria-peca-fornecedor/novo",
        name: "Nova Categoria Peça Fornecedor",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/CategoriaPecaFornecedor/Form.vue"),
      },
      {
        path: "categoria-peca-fornecedor/:id",
        name: "Edição de Categoria Peça Fornecedor",
        meta: { isAdminRoute: true },
        component: () =>
          import("../views/Pages/Admin/CategoriaPecaFornecedor/Form.vue"),
      },
      {
        path: "categoria-peca-profissional-independente",
        name: "Categoria Peça Profissional Independente",
        meta: { isAdminRoute: true },
        component: () =>
          import(
            "../views/Pages/Admin/CategoriaPecaProfissionalIndependente/List.vue"
          ),
      },
      {
        path: "categoria-peca-profissional-independente/novo",
        name: "Nova Categoria Peça Profissional Independente",
        meta: { isAdminRoute: true },
        component: () =>
          import(
            "../views/Pages/Admin/CategoriaPecaProfissionalIndependente/Form.vue"
          ),
      },
      {
        path: "categoria-peca-profissional-independente/:id",
        name: "Edição de Categoria Peça Profissional Independente",
        meta: { isAdminRoute: true },
        component: () =>
          import(
            "../views/Pages/Admin/CategoriaPecaProfissionalIndependente/Form.vue"
          ),
      },
      {
        path: "jurado-resposta",
        name: "Resposta de Jurado",
        meta: { isAdminRoute: true },
        component: () => import("../views/Pages/Admin/JuradoResposta/List.vue"),
      },
    ],
  },
  {
    path: "/",
    redirect: "login",
    component: AuthLayout,
    children: [
      {
        path: "/login",
        name: "login",
        meta: { isAuthRoute: true },
        component: () => import("../views/Pages/Public/Login.vue"),
      },
      {
        path: "/jurado",
        name: "juradoLogin",
        meta: { isAuthRoute: true },
        component: () => import("../views/Pages/Public/LoginJurado.vue"),
        props: true,
      },
      {
        path: "/cadastro/jurado",
        name: "cadastroJurado",
        meta: { isAuthRoute: true },
        component: () =>
          import("../views/Pages/Public/Cadastro/JuradoUserForm.vue"),
        props: true,
      },
      {
        path: "/cadastro",
        name: "cadastro",
        meta: { isAuthRoute: true },
        component: () => import("../views/Pages/Public/Cadastro/Inicio.vue"),
      },
      {
        path: "/cadastro/agencia",
        name: "cadastroAgencia",
        meta: { isAuthRoute: true },
        component: () =>
          import("../views/Pages/Public/Cadastro/PublicitarioUserForm.vue"),
        props: true,
      },
      {
        path: "/cadastro/estudante",
        name: "cadastroEstudante",
        meta: { isAuthRoute: true },
        component: () =>
          import("../views/Pages/Public/Cadastro/EstudanteUserForm.vue"),
        props: true,
      },
      {
        path: "/cadastro/fornecedor",
        name: "cadastroFornecedor",
        meta: { isAuthRoute: true },
        component: () =>
          import("../views/Pages/Public/Cadastro/FornecedorUserForm.vue"),
        props: true,
      },
      {
        path: "/cadastro/profissional-independente",
        name: "cadastroProfissionalIndependente",
        meta: { isAuthRoute: true },
        component: () =>
          import(
            "../views/Pages/Public/Cadastro/ProfissionalIndependenteUserForm.vue"
          ),
        props: true,
      },
      {
        path: "/cadastro/profissional",
        name: "cadastroProfissional",
        meta: { isAuthRoute: true },
        component: () =>
          import("../views/Pages/Public/Cadastro/ProfissionalUserForm.vue"),
        props: true,
      },
      {
        path: "/cadastro/profissional/fim",
        name: "cadastroProfissionalFim",
        meta: { isAuthRoute: true },
        component: () =>
          import(
            "../views/Pages/Public/Cadastro/ProfissionalAgradecimento.vue"
          ),
        props: true,
      },
      { path: "*", component: NotFound },
    ],
  },
];

export default routes;
